import { type IconComponent, SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

interface GlyphProps {
    icon: IconComponent;
}

/** A decorative board icon, sized with the text beside it and hidden from screen readers. */
export default function Glyph(props: GlyphProps) {
    return (
        <SvgIcon
            icon={props.icon}
            size="inherit"
            svgProps={{ 'aria-hidden': true, focusable: 'false' }}
        />
    );
}
